export default "__VITE_ASSET__Dixz2r5i__"